import { render } from "./BaoCaoHoatDongYTeKiemDichThangDaGoi.vue?vue&type=template&id=24598f2e&ts=true"
import script from "./BaoCaoHoatDongYTeKiemDichThangDaGoi.vue?vue&type=script&lang=ts"
export * from "./BaoCaoHoatDongYTeKiemDichThangDaGoi.vue?vue&type=script&lang=ts"

import "./BaoCaoHoatDongYTeKiemDichThangDaGoi.vue?vue&type=style&index=0&id=24598f2e&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__